import { useEffect, useState } from "react";
import { getCookies } from "cookies-next";
import axios from "axios";
import Swal from "sweetalert2";
import { config } from "../../data/config";
import BreadCrump from "../tools/breadcrump";
import HeaderOfPage from "../tools/headerOfPage";
import { useTranslation } from "react-i18next";
import changeUrl from "../../hoc/changeur";

export default function ListArticles() {
  const { t } = useTranslation();

  const breadcrump = [
    { name: "Dashboard", url: "/dashboard" },
    { name: "Blog", url: "/dashboard/Blog" },
    { name: "List Article", url: null },
  ];

  const [key, setKey] = useState(1);
  const reloadItems = () => setKey((prev) => prev + 1);

  return (
    <div className="p-4 bg-gray-50 min-h-screen">
      <BreadCrump data={breadcrump} />
      <HeaderOfPage name="List Article" />
      <div className="grid grid-cols-1 sm:grid-cols-4 gap-6 mt-4">
        <div className="col-span-1">
          <NewBlogCategory reloaditem={reloadItems} />
        </div>
        <div className="col-span-3">
          <ListofBlog key={key} />
        </div>
      </div>
    </div>
  );
}

// -------------------- List of Blog --------------------
function ListofBlog() {
  const { t } = useTranslation();
  const cookie = getCookies();
  const [list, setList] = useState<any>(null);
  const [listgroup, setListGroup] = useState<any>(null);
  const [name, setName] = useState("");
  const [group, setGroup] = useState("");
  
  // Language selector state - default to Persian (fa)
  const [languages, setLanguages] = useState<Array<{ code: string; label: string }>>([]);
  const [activeLang, setActiveLang] = useState<string>('fa'); // Default to Persian
  
  // Load languages
  const loadLanguages = async () => {
    try {
      const res = await axios.get(`${config.url}/v1/language`);
      const languageList = res.data?.message ?? [];
      const mapped = languageList
        .filter((lang: any) => lang.active)
        .sort((a: any, b: any) => (a.arranged ?? 0) - (b.arranged ?? 0))
        .map((lang: any) => ({ code: lang.code, label: lang.label }));
      setLanguages(mapped);
      // Set default to Persian if available, otherwise first language
      const faLang = mapped.find((l: { code: string; label: string }) => l.code === 'fa');
      if (faLang) {
        setActiveLang('fa');
      } else if (mapped.length > 0) {
        setActiveLang(mapped[0].code);
      }
    } catch (e) {
      console.error('Error loading languages:', e);
      const fallback = [
        { code: 'ku', label: 'Kurdish' },
        { code: 'fa', label: 'فارسی' },
        { code: 'en', label: 'English' },
        { code: 'ar', label: 'العربية' },
        { code: 'tr', label: 'Türkçe' }
      ];
      setLanguages(fallback);
      setActiveLang('fa');
    }
  };
  
  // Helper function to get multilingual value
  const getMultilingualValue = (field: any, lang: string): string => {
    if (!field) return '';
    if (typeof field === 'string') return field;
    if (typeof field === 'object') {
      return field[lang] || field.en || field.fa || field.ku || field.ar || field.tr || '';
    }
    return '';
  };

  const loaddata = async (page = 1) => {
    try {
      const res = await axios.get(`${config.url}/v1/dashboard/post`, {
        headers: { Authorization: "Bearer " + cookie.token },
        params: { page, name, group },
      });
      setList(res.data.message);
    } catch (err) {}
  };

  const getGroups = async () => {
    try {
      const res = await axios.get(`${config.url}/v1/dashboard/bloggroup`, {
        headers: { Authorization: "Bearer " + cookie.token },
      });
      setListGroup(res.data.message);
    } catch (err) {}
  };

  const deleted = async (id: any) => {
    Swal.fire({
      title: t("Are you sure?"),
      text: t("Delete this Post!"),
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: t("Yes, delete it"),
    }).then(async (result) => {
      if (result.isConfirmed) {
        await axios.delete(`${config.url}/v1/dashboard/post/${id}`, {
          headers: { Authorization: "Bearer " + cookie.token },
        });
        loaddata(1);
      }
    });
  };

  useEffect(() => {
    loadLanguages();
    loaddata(1);
    getGroups();
  }, []);

  const limitText = (text: string, maxLength: number) =>
    text.length > maxLength ? text.slice(0, maxLength) + "..." : text;

  const langList = languages.length > 0 ? languages : [
    { code: 'ku', label: 'Kurdish' },
    { code: 'fa', label: 'فارسی' },
    { code: 'en', label: 'English' },
    { code: 'ar', label: 'العربية' },
    { code: 'tr', label: 'Türkçe' }
  ];

  return (
    <div className="bg-white p-4 rounded-lg shadow-md">
      {/* Language Selector */}
      <div className="mb-4 pb-4 border-b border-gray-200">
        <div className="flex items-center gap-3 flex-wrap">
          <span className="text-sm font-medium text-gray-700">زبان:</span>
          <div className="flex gap-2 flex-wrap">
            {langList.map((lang) => (
              <button
                key={lang.code}
                type="button"
                onClick={() => setActiveLang(lang.code)}
                className={`px-3 py-1.5 text-sm font-medium rounded-lg transition-colors ${
                  activeLang === lang.code
                    ? 'bg-blue-600 text-white'
                    : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                }`}
              >
                {lang.label}
              </button>
            ))}
          </div>
        </div>
      </div>
      
      {/* Filter Section */}
      <div className="grid grid-cols-1 sm:grid-cols-5 gap-4 mb-4">
        <input
          placeholder={t("Search by Slug")}
          value={name}
          onChange={(e) => setName(e.target.value)}
          className="col-span-2 border border-gray-300 rounded px-3 py-2 focus:ring-2 focus:ring-blue-400 focus:outline-none"
        />
        <select
          className="col-span-2 border border-gray-300 rounded px-3 py-2 focus:ring-2 focus:ring-blue-400 focus:outline-none"
          onChange={(e) => setGroup(e.target.value)}
        >
          <option value="">{t("Select Group")}</option>
            {listgroup &&
            listgroup.map((g: any) => {
              const displayName = getMultilingualValue(g.name, activeLang);
              return (
                <option key={g.id} value={g.id}>
                  {displayName}
                </option>
              );
            })}
        </select>
        <button
          className="col-span-1 bg-blue-500 hover:bg-blue-600 text-white font-semibold px-3 py-2 rounded"
          onClick={() => loaddata(1)}
        >
          {t("Filter")}
        </button>
      </div>

      {/* Blog Table */}
      <div className="overflow-x-auto" dir="rtl">
        <table className="min-w-full divide-y divide-gray-200 text-right">
          <thead className="bg-gray-100">
            <tr>
              <th className="px-4 py-2 text-xs w-[100px]   text-right font-medium text-gray-500 uppercase">
                {t("Order")}
              </th>
              <th className="px-4 py-2 text-xs font-medium text-gray-500 uppercase">
                {t("Name")}
              </th>
              <th className="px-4 py-2 text-xs font-medium text-gray-500 uppercase">
                {t("Group")}
              </th>
              <th className="px-4 py-2 text-xs font-medium text-gray-500 uppercase">
                {t("Action")}
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200">
            {list?.docs?.map((item: any) => (
              <tr key={item.id} className="hover:bg-gray-50  items-center justify-center">
                <td className="px-4 py-2 flex gap-2 justify-items-start  pt-6 ">
                  <button>
                    <img src="/icons/arrowndown.svg" className="w-5" />
                  </button>
                  <button>
                    <img src="/icons/arrowup.svg" className="w-5" />
                  </button>
                </td>
                <td className="px-4 py-2">
                  <p className="font-medium">
                    {getMultilingualValue(item.name, activeLang) || 'بدون نام'}
                  </p>
                  <p className="text-gray-400 text-xs">
                    {limitText(getMultilingualValue(item.url, activeLang), 30)}
                  </p>
                </td>
                <td className="px-4 py-2">
                  {getMultilingualValue(item.toGroup?.name, activeLang) || '-'}
                </td>
                <td className="px-4 py-2 flex gap-2">
                  <a href={`/dashboard/Blog/EditPost/${item.id}`}>
                    <img src="/icons/editgreen.svg" className="w-5" />
                  </a>
                  <button onClick={() => deleted(item.id)}>
                    <img src="/icons/delred.svg" className="w-5" />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {list && list.totalPages > 1 && (
        <div className="mt-4 pt-4 border-t border-gray-200 flex items-center justify-between flex-wrap gap-3">
          <div className="text-sm text-gray-600">
            {t("Showing")} {((list.page - 1) * list.limit) + 1} {t("to")}{" "}
            {Math.min(list.page * list.limit, list.totalDocs)} {t("of")} {list.totalDocs}
          </div>
          <nav className="flex items-center gap-2">
            <button
              type="button"
              disabled={!list.hasPrevPage}
              onClick={() => loaddata(list.page - 1)}
              className="px-3 py-1.5 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 disabled:opacity-40 disabled:pointer-events-none"
            >
              {t("Previous")}
            </button>
            {Array.from({ length: list.totalPages }, (_, index) => {
              const pageNum = index + 1;
              return (
                <button
                  key={pageNum}
                  type="button"
                  onClick={() => loaddata(pageNum)}
                  className={`px-3 py-1.5 text-sm font-medium rounded-lg ${
                    list.page === pageNum
                      ? "bg-blue-600 text-white"
                      : "bg-white text-gray-700 border border-gray-300 hover:bg-gray-50"
                  }`}
                >
                  {pageNum}
                </button>
              );
            })}
            <button
              type="button"
              disabled={!list.hasNextPage}
              onClick={() => loaddata(list.page + 1)}
              className="px-3 py-1.5 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 disabled:opacity-40 disabled:pointer-events-none"
            >
              {t("Next")}
            </button>
          </nav>
        </div>
      )}
    </div>
  );
}

type LanguageCode = string;

interface MultilingualField {
    [key: string]: string;
}

interface PostData {
    name: MultilingualField;
    url: MultilingualField;
    keywords: MultilingualField;
    description: MultilingualField;
    code: string;
    parent: string | null;
}

// Helper function to get display name from multilingual or string
const getDisplayName = (name: any): string => {
    if (!name) return '';
    if (typeof name === 'string') return name;
    if (typeof name === 'object') {
        return name.en || name.fa || name.ku || name.ar || name.tr || '';
    }
    return String(name);
};

// -------------------- New Blog Category --------------------
function NewBlogCategory({ reloaditem }: any) {
  const { t } = useTranslation();
  const cookie = getCookies();
  const [data, setData] = useState<PostData>({
    name: {},
    url: {},
    keywords: {},
    description: {},
    code: '',
    parent: null,
  });
  const [list, setList] = useState<any>(null);
  const [error, setError] = useState<any>(null);
  const [key, setKey] = useState(1);
  const [saving, setSaving] = useState(false);
  const [activeLang, setActiveLang] = useState<LanguageCode>('en');
  const [languages, setLanguages] = useState<Array<{ code: LanguageCode; label: string }>>([]);

  // Load languages
  const loadLanguages = async (): Promise<Array<{ code: LanguageCode; label: string }>> => {
    try {
      const res = await axios.get(`${config.url}/v1/language`);
      const languageList = res.data.message || [];
      // Map backend language format to frontend format
      const mappedLanguages = languageList
        .filter((lang: any) => lang.active) // Only show active languages
        .sort((a: any, b: any) => (a.arranged || 0) - (b.arranged || 0)) // Sort by arranged order
        .map((lang: any) => ({
          code: lang.code as LanguageCode,
          label: lang.label
        }));
      setLanguages(mappedLanguages);
      // Set default active language to first language or 'en'
      if (mappedLanguages.length > 0) {
        setActiveLang(mappedLanguages[0].code);
      }
      return mappedLanguages;
    } catch (error) {
      console.error('Error loading languages:', error);
      // Fallback to default languages if API fails
      const fallbackLanguages = [
        { code: 'ku' as LanguageCode, label: 'Kurdish' },
        { code: 'fa' as LanguageCode, label: 'فارسی' },
        { code: 'en' as LanguageCode, label: 'English' },
        { code: 'ar' as LanguageCode, label: 'العربية' },
        { code: 'tr' as LanguageCode, label: 'Türkçe' }
      ];
      setLanguages(fallbackLanguages);
      return fallbackLanguages;
    }
  };

  // Helper function to initialize multilingual field
  const initializeMultilingualField = (field: any, languageCodes: string[]): MultilingualField => {
    if (!field) {
      const obj: MultilingualField = {};
      languageCodes.forEach(code => obj[code] = '');
      return obj;
    }
    if (typeof field === 'string') {
      const obj: MultilingualField = {};
      languageCodes.forEach(code => obj[code] = field);
      return obj;
    }
    if (typeof field === 'object') {
      const obj: MultilingualField = { ...field };
      languageCodes.forEach(code => {
        if (!obj[code]) obj[code] = '';
      });
      return obj;
    }
    const obj: MultilingualField = {};
    languageCodes.forEach(code => obj[code] = '');
    return obj;
  };

  // Helper function to safely access multilingual fields
  const getMultilingualValue = (field: MultilingualField, lang: LanguageCode): string => {
    return field[lang] || '';
  };

  const setName = (name: string) => {
    const updatedName = {
      ...data.name,
      [activeLang]: name
    };

    const updatedUrl = { ...data.url };
    updatedUrl[activeLang] = String(changeUrl(name)); // Slug generated for active language

    setData((prev: PostData) => ({
      ...prev,
      url: updatedUrl,
      name: updatedName
    }));
  };

  const save = async () => {
    setError(null);
    setSaving(true);
    try {
      await axios.post(`${config.url}/v1/dashboard/post`, data, {
        headers: { Authorization: "Bearer " + cookie.token },
      });
      Swal.fire({
        icon: 'success',
        title: t('Success'),
        text: t('Post added successfully'),
        timer: 1500,
        showConfirmButton: false
      });
      // Reset form with current languages
      const languageCodes = languages.length > 0 
        ? languages.map(l => l.code)
        : ['ku', 'fa', 'en', 'ar', 'tr'];
      const emptyMultilingualField: MultilingualField = {};
      languageCodes.forEach(code => emptyMultilingualField[code] = '');
      setData({
        name: { ...emptyMultilingualField },
        url: { ...emptyMultilingualField },
        keywords: { ...emptyMultilingualField },
        description: { ...emptyMultilingualField },
        code: '',
        parent: null,
      });
      reloaditem();
      setKey((prev) => prev + 1);
    } catch (err: any) {
      Swal.fire({
        icon: 'error',
        title: t('Error'),
        text: err.response?.data?.message || t('Failed'),
      });
      setError(err.response?.data?.message?.errors || null);
    } finally {
      setSaving(false);
    }
  };

  useEffect(() => {
    const initialize = async () => {
      await loadLanguages();
      const res = await axios.get(`${config.url}/v1/dashboard/bloggroup`, {
        headers: { Authorization: "Bearer " + cookie.token },
      });
      setList(res.data.message);
    };
    initialize();
  }, []);

  const inputStyle =
    "w-full border border-gray-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 focus:outline-none bg-white text-gray-900";

  return (
    <div className="bg-white rounded-xl shadow-sm p-6" dir="rtl">
      <h3 className="text-lg font-semibold text-gray-800 mb-4">{t("New Post")}</h3>
      
      {error && (
        <div className="mb-4 p-3 bg-red-50 border border-red-200 rounded-lg">
          <p className="text-sm text-red-800">{error}</p>
        </div>
      )}

      <form className="space-y-4">
        {/* Language Selector */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            زبان
          </label>
          <div className="flex gap-2 flex-wrap">
            {languages.map((lang) => (
              <button
                key={lang.code}
                type="button"
                onClick={() => setActiveLang(lang.code)}
                className={`px-3 py-1.5 text-sm font-medium rounded-lg transition-colors ${
                  activeLang === lang.code
                    ? 'bg-blue-600 text-white'
                    : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                }`}
              >
                {lang.label}
              </button>
            ))}
          </div>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Code <span className="text-red-500">*</span>
          </label>
          <input
            type="text"
            value={data.code}
            className={inputStyle}
            placeholder="مثال: POST001"
            onChange={(e) => setData((prev: PostData) => ({ ...prev, code: e.target.value }))}
            required
          />
          <p className="mt-1 text-xs text-gray-500">کد یکتای پست (به انگلیسی و بدون فاصله)</p>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            {t("Name")} ({languages.find(l => l.code === activeLang)?.label}) <span className="text-red-500">*</span>
          </label>
          <input
            type="text"
            value={getMultilingualValue(data.name, activeLang)}
            className={inputStyle}
            placeholder="نام پست را وارد کنید"
            onChange={(e) => setName(e.target.value)}
            required
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            URL ({languages.find(l => l.code === activeLang)?.label}) <span className="text-red-500">*</span>
          </label>
          <input
            type="text"
            value={getMultilingualValue(data.url, activeLang)}
            className={inputStyle}
            placeholder="slug"
            onChange={(e) => setData((prev: PostData) => ({
              ...prev,
              url: {
                ...prev.url,
                [activeLang]: e.target.value
              }
            }))}
            required
          />
          <p className="mt-1 text-xs text-gray-500">به صورت خودکار از نام تولید می‌شود</p>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            {t("Group")}
          </label>
          <select
            className={inputStyle}
            onChange={(e) => setData((prev: PostData) => ({ ...prev, parent: e.target.value || null }))}
          >
            <option value="">{t("Choose Group")}...</option>
            {list?.map((g: any) => (
              <option key={g.id} value={g.id}>
                {getDisplayName(g.name)}
              </option>
            ))}
          </select>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            {t("Keywords")} ({languages.find(l => l.code === activeLang)?.label})
          </label>
          <textarea
            rows={3}
            value={getMultilingualValue(data.keywords, activeLang)}
            className={inputStyle}
            onChange={(e) => setData((prev: PostData) => ({
              ...prev,
              keywords: {
                ...prev.keywords,
                [activeLang]: e.target.value
              }
            }))}
            placeholder="کلمات کلیدی (با کاما جدا کنید)"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            {t("Description")} ({languages.find(l => l.code === activeLang)?.label})
          </label>
          <textarea
            rows={4}
            value={getMultilingualValue(data.description, activeLang)}
            className={inputStyle}
            onChange={(e) => setData((prev: PostData) => ({
              ...prev,
              description: {
                ...prev.description,
                [activeLang]: e.target.value
              }
            }))}
            placeholder="توضیحات پست"
          />
        </div>

        <button
          type="button"
          onClick={save}
          disabled={saving || !getMultilingualValue(data.name, activeLang) || !data.code || !getMultilingualValue(data.url, activeLang)}
          className="w-full inline-flex items-center justify-center gap-x-2 px-6 py-2.5 text-sm font-medium rounded-lg border border-transparent bg-blue-600 text-white hover:bg-blue-700 focus:outline-none focus:bg-blue-700 disabled:opacity-50 disabled:pointer-events-none transition-colors"
        >
          {saving ? (
            <>
              <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
              در حال ذخیره...
            </>
          ) : (
            <>
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
              </svg>
              {t("Save")}
            </>
          )}
        </button>
      </form>
    </div>
  );
}
